module.exports = __webpack_public_path__ + "assets/img/NPC036.a29783e3.png";